export default "__VITE_ASSET__Be7FFMnK__"